<template>
  <b-col
    cols="3"
    style="margin-right: 0.05rem;"
  >
    <b-card
      class="box"
      no-body
    >
      <b-row align-h="end">
        <b-col cols="auto">
          <b-dropdown
            variant="none"
            no-caret
          >
            <template #button-content>
              <feather-icon
                icon="MoreHorizontalIcon"
                size="20"
              />
            </template>
            <b-dropdown-item-btn @click="excluirTela">
              Remover
            </b-dropdown-item-btn>
          </b-dropdown>
        </b-col>
      </b-row>
      <b-row
        class="mt-1 mb-2"
        align-h="center"
      >
        <b-col cols="auto">
          <feather-icon
            v-if="!value_ || !value_.id"
            class="color-icon-action"
            icon="PlusCircleIcon"
            size="36"
            @click="abrirSelecao"
          />
          <div
            v-else
            class="icone-click-acao"
            @click="irParaTela(value_)"
          >
            <font-awesome-icon
              class="text-primary"
              :icon="getIconeRecurso(value_)"
              style="font-size: 2.3rem !important;cursor: pointer;"
            />
          </div>
        </b-col>
      </b-row>
      <b-row
        align-h="center"
        style="margin-top: -.8rem"
      >
        <b-col cols="auto">
          <span class="texto-interno">{{ value_.descricao ? value_.descricao : '' }}</span>
        </b-col>
      </b-row>
    </b-card>
    <b-modal
      ref="modalTeste"
      no-close-on-esc
      no-close-on-backdrop
      title="Adicionar favorito"
      hide-header-close
      hide-footer
      size="sm"
    >
      <div style="font-size: 14px;margin-top: .5rem;">
        <b-form-group label="Escolha a tela">
          <v-select
            v-model="recursoSelecionado"
            :options="recurso"
            :label="'descricao'"
            :clearable="false"
          />
        </b-form-group>
      </div>
      <div
        class="mt-2"
        style="display: flex;justify-content: flex-end;"
      >
        <b-btn
          size="sm"
          variant="danger"
          class="mr-50"
          @click="fechar"
        >
          Cancelar
        </b-btn>
        <b-btn
          size="sm"
          variant="primary"
          @click="salvarTela"
        >
          Confirmar
        </b-btn>
      </div>
    </b-modal>

  </b-col>
</template>

<style lang="scss">
.box {
  box-shadow: 1px 2px 5px 4px rgb(20 20 20 / 40%);
  border-radius: 0.428rem;
  height: 150px;
  min-height: 150px;
  max-height: 150px;
}

.texto-interno {
  font-size: 16px;
  font-weight: 500;
}

.color-icon-action {
  color: var(--primary);
  cursor: pointer;
}

.icone-click-acao {
  cursor: pointer;
  padding-left: 5rem;
  padding-right: 5rem;
  padding-top: 1.5rem;
  padding-bottom: 1rem;
  margin-top: -1.7rem;
}
</style>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import vSelect from 'vue-select'
import { isAdmin, getAbilitys } from '@/auth/utils'
import interno from '@/navigation/vertical-interno'
import api from '@/app-modulo/comuns/favoritos/shared/services/api'

export default {
  name: 'Favorito',
  components: {
    vSelect,
    FontAwesomeIcon,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    titulo: {
      type: String,
      default: '',
    },
    idUsuario: {
      type: Number,
      default: 0,
    },
    identificador: {
      type: Number,
      required: true,
    },
    telas: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      recurso: [],
      recursoSelecionado: null,
      valueInner: null,
      telasSalvas: [],
    }
  },
  computed: {
    value_: {
      get() {
        return this.valueInner ? this.valueInner : this.value
      },
      set(newValue) {
        this.valueInner = newValue
        return this.valueInner
      },
    },
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.valueInner = newValue
      }
    },
    telas(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.telasSalvas = newValue
      }
    },
  },
  created() {
    this.valueInner = this.value
    this.telasSalvas = this.telas
  },
  methods: {
    abrirSelecao() {
      this.$refs.modalTeste.show()
      this.recurso = []
      api.getRecursos()
        .then(payload => {
          const recursos = payload.data.filter(fil => !this.telasSalvas.some(som => som.nomeRecurso === fil.recursoNome))
          if (isAdmin()) {
            this.recurso = recursos
          } else {
            const ability = getAbilitys()
            for (let i = 0; i < getAbilitys().length; i += 1) {
              for (let j = 0; j < recursos.length; j += 1) {
                if (ability[i].subject === recursos[j].recursoNome) {
                  this.recurso.push(recursos[j])
                }
              }
            }
          }
        })
        .catch(err => {
          this.$erro(err.response.data.message || err.message)
          throw err
        })
    },
    fechar() {
      this.recursoSelecionado = null
      this.$refs.modalTeste.hide()
    },
    salvarTela() {
      if (this.recursoSelecionado) {
        api.salvarTela(this.recursoSelecionado, this.idUsuario)
          .then(payload => {
            this.valueInner = payload.data
            this.$emit('tela-salva', { tela: this.valueInner, index: this.identificador })
            this.$sucesso('Tela favorita salva!')
            this.fechar()
          })
          .catch(err => {
            this.$erro(err.response.data.message || err.message)
            throw err
          })
      }
    },
    excluirTela() {
      // eslint-disable-next-line no-underscore-dangle
      if (this.value_ && this.value_.id) {
        // eslint-disable-next-line no-underscore-dangle
        api.deletarTela(this.value_.id)
          .then(() => {
            this.valueInner = {}
            this.$emit('tela-removida', { tela: this.value, index: this.identificador })
            this.$sucesso('Tela favorita removida!')
          })
          .catch(err => {
            this.$erro(err.response.data.message || err.message)
            throw err
          })
      }
    },
    irParaTela(value) {
      const permitidoAcessar = getAbilitys()
      if (!isAdmin() && !permitidoAcessar.some(som => som.subject === value.nomeRecurso)) {
        this.$erro('Você não tem permissão para acessar esse recurso!')
      } else {
        const menu = interno.filter(fil => fil.children.some(som => som.resource === value.nomeRecurso))
        if (menu && menu[0]) {
          const children = menu[0].children.find(find => find.resource === value.nomeRecurso)
          if (children && children.route) {
            if (children.route.path) {
              this.$router.push({ path: children.route.path })
            } else {
              this.$router.push({ name: children.route.name })
            }
          }
        }
      }
    },
    getIconeRecurso(value) {
      if (value.nomeRecurso === 'departamento') {
        return ['fas', 'network-wired']
      }
      if (value.nomeRecurso === 'empresa') {
        return ['fas', 'building']
      }
      if (value.nomeRecurso === 'gruposempresariais') {
        return ['fas', 'city']
      }
      if (value.nomeRecurso === 'equipe') {
        return ['fas', 'users']
      }
      if (value.nomeRecurso === 'indicacao') {
        return ['fas', 'user-plus']
      }
      if (value.nomeRecurso === 'pacoteservico') {
        return ['fas', 'boxes-stacked']
      }
      if (value.nomeRecurso === 'pessoa') {
        return ['fas', 'person']
      }
      if (value.nomeRecurso === 'servico') {
        return ['fas', 'screwdriver-wrench']
      }
      if (value.nomeRecurso === 'tributacao') {
        return ['fas', 'coins']
      }
      if (value.nomeRecurso === 'dashboardcobranca') {
        return ['fas', 'chart-pie']
      }
      if (value.nomeRecurso === 'usuexterno') {
        return ['fas', 'building-user']
      }
      if (value.nomeRecurso === 'usuinterno') {
        return ['fas', 'user']
      }
      if (value.nomeRecurso === 'funcao') {
        return ['fas', 'briefcase']
      }
      if (value.nomeRecurso === 'atividade') {
        return ['fas', 'bullseye']
      }
      if (value.nomeRecurso === 'painelproposta') {
        return ['fas', 'square-poll-horizontal']
      }
      if (value.nomeRecurso === 'parametrizacaochecklist') {
        return ['fas', 'list-check']
      }
      if (value.nomeRecurso === 'parametrizacaogeral') {
        return ['fas', 'gears']
      }
      if (value.nomeRecurso === 'template') {
        return ['fas', 'file-contract']
      }
      if (value.nomeRecurso === 'documento') {
        return ['fas', 'file-lines']
      }
      if (value.nomeRecurso === 'modelo') {
        return ['fas', 'file-circle-plus']
      }
      if (value.nomeRecurso === 'portaldocumentosinterno') {
        return ['fas', 'clock-rotate-left']
      }
      if (value.nomeRecurso === 'grupo') {
        return ['fas', 'users-gear']
      }
      if (value.nomeRecurso === 'email') {
        return ['fas', 'envelope']
      }
      if (value.nomeRecurso === 'proprietario') {
        return ['fas', 'user-tie']
      }
      if (value.nomeRecurso === 'log') {
        return ['fas', 'lock']
      }
      return ['fas', 'chart-line']
    },
  },
}
</script>
